import { render } from "./LinkedInIcon.vue?vue&type=template&id=41d4b6e8&bindings={}"
import script from "./LinkedInIcon.vue?vue&type=script&lang=ts"
export * from "./LinkedInIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script